var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"search\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#000\" fill-rule=\"nonzero\" d=\"M13.4 5a9.4 9.4 0 1 1 0 18.8 9.4 9.4 0 0 1 0-18.8m0 2a7.4 7.4 0 1 0 0 14.8 7.4 7.4 0 0 0 0-14.8\" /><path stroke=\"#000\" stroke-width=\"2\" d=\"m19.604 19.804 7.808 6.247\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol